"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priceWrapper = exports.actions = exports.scripDetails = exports.graph = exports.name = exports.wrapper = exports.root = void 0;

var _util = require("../../../util");

const graphWidth = 56;

const root = ({
  cssProps,
  theme
}) => {
  const {
    actions,
    selected,
    simplifyStyles,
    onClick
  } = cssProps;
  return {
    background: !simplifyStyles ? (0, _util.color)(theme, selected ? 'interactive.ui.hover' : 'interactive.ui.default') : 'initial',
    minHeight: 56,
    maxHeight: 75,
    position: 'relative',
    transition: 'background 0.2s ease',
    '&:hover': !simplifyStyles ? {
      cursor: onClick ? 'pointer' : undefined,
      background: (0, _util.color)(theme, 'interactive.ui.hover'),
      ...(actions ? {
        '& [data-name="scripDetails"]': {
          opacity: 0
        },
        '& [data-name="actions"]': {
          height: '100%',
          alignItems: 'center',
          opacity: 1,
          pointerEvents: 'initial',
          transform: 'none'
        }
      } : {})
    } : {}
  };
};

exports.root = root;

const wrapper = () => ({
  position: 'relative'
});

exports.wrapper = wrapper;

const name = () => ({
  width: "calc(55% - ".concat(graphWidth / 2 + 8, "px)")
});

exports.name = name;

const graph = () => ({
  width: graphWidth
});

exports.graph = graph;

const scripDetails = () => ({
  alignSelf: 'stretch',
  overflow: 'hidden',
  position: 'relative'
});

exports.scripDetails = scripDetails;

const actions = () => ({
  opacity: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(10%)',
  transition: 'all 0.2s ease',
  right: 0
});

exports.actions = actions;

const priceWrapper = ({
  cssProps
}) => ({
  height: cssProps === null || cssProps === void 0 ? void 0 : cssProps.height,
  justifyContent: 'space-around',
  alignItems: 'flex-end',
  flexDirection: 'column'
});

exports.priceWrapper = priceWrapper;
//# sourceMappingURL=ScripCell.style.js.map